<template>
  <div class="site-header">
    <div class="site-header-view">

      <div class="mobile-nav" @click="onMobileNav">
        <i class="el-icon-s-unfold" v-if="!isShowNav"></i>
        <i class="el-icon-s-fold" v-else></i>
      </div>

      <div class="breadcrumb">
        <div class="breadcrumb-item" v-for="(item, key) in breadcrumbs" :key="key">{{ item.title }} <i class="b-arrow"
            v-if="key === 0 && breadcrumbs.length > 1"></i> </div>
      </div>

      <div class="info">
        <AiService />
        <div class="lang">
          <el-dropdown trigger="click">
            <span class="lang-icon">
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleLangClick('zh')">中文</el-dropdown-item>
              <el-dropdown-item @click.native="handleLangClick('en')">English</el-dropdown-item>
              <el-dropdown-item @click.native="handleLangClick('ja')">日本語</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="esc" @click="escLogin"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import cookie from '@utils/cookie'
import AiService from '@/components/AiService'
export default {
  name: 'SiteHeader',
  data () {
    return {
      markets: ''
    }
  },
  mounted () {
    this.init()
    this.getMarkets()
  },
  computed: {
    ...mapState(['device', 'isShowNav', 'userInfo', 'breadcrumbs'])
  },
  components: {
    AiService
  },
  methods: {
    init () {
      console.log('this', this.$route)
    },
    getMarkets () {
      this.markets = +cookie.get('national_market')
      this.$store.commit('SET_MARKET_ID', this.markets)
      this.$store.commit('SET_NATIONAL_MARKET_CURRENCY', cookie.get('national_market_currency'))
      const countryInfo = localStorage.getItem('CURRENT_COUNTRY_INFO') ? JSON.parse(localStorage.getItem('CURRENT_COUNTRY_INFO')) : null
      if (countryInfo) {
        this.$store.commit('SET_CURRENT_COUNTRY_INFO', countryInfo)
      }
    },
    setMarkets (item) {
      this.markets = item.id
      cookie.set('national_market', item.id || '')
      cookie.set('national_market_currency', item.currency || '')
      localStorage.setItem('CURRENT_COUNTRY_INFO', JSON.stringify(item))
      this.$store.commit('SET_MARKET_ID', item.id)
      this.$store.commit('SET_NATIONAL_MARKET_CURRENCY', item.currency)
      this.$store.commit('SET_CURRENT_COUNTRY_INFO', item)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    onMobileNav () {
      this.$store.commit('SET_IS_SHOW_NAV', !this.isShowNav)
    },
    escLogin () {
      cookie.delete('kg-client-token')
      this.$router.push({ name: 'signIn' })
      sessionStorage.setItem('dialogRuleVisible', null)
      sessionStorage.setItem(`dialogMnemonicWordsVisible_${this?.userInfo?.account_id}`, null)
    },
    handleLangClick (val) {
      const langs = {
        zh: 'zh-CN',
        en: 'en-us',
        ja: 'ja'
      }
      this.$i18n.locale = val
      localStorage.setItem('lang', val)
      cookie.set('lang', langs[val])
      window.location.reload()
    }
  }
}
</script>

<style scoped lang="scss">
.site-header {
  width: 100%;

  .site-header-view {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 30px;
    padding-right: 20px;
    padding-top: 5px;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 97%;
      position: absolute;
      bottom: 0;
      height: 15px;
      background: url('../../assets/img/hd-line.png') no-repeat left / 100% auto;
    }

    .mobile-nav {
      display: none;
    }

    .breadcrumb {
      display: flex;
      padding-left: 21px;
      align-items: center;

      .breadcrumb-item {
        color: #fff;
        display: flex;
        align-items: center;

        &:nth-child(1) {
          font-size: 20px;
          color: #01b2f5;
        }

        &:nth-child(2) {
          font-size: 16px;
          color: #01b2f5;
        }

        .b-arrow {
          content: '';
          display: block;
          width: 15px;
          height: 21px;
          margin: 0 5px;
          background: url('../../assets/img/breadcrumb-arrow.png') no-repeat center /100%;
        }
      }
    }

    .countrys {
      display: flex;

      .countrys-item {
        width: 40px;
        height: 40px;
        margin-right: 50px;
        border: 2px solid transparent;
        cursor: pointer;

        &.item3 {
          background: url('../../assets/img/country/yd.png') no-repeat center / 100% 100%;
        }

        &.item2 {
          background: url('../../assets/img/country/xg.png') no-repeat center / 100% 100%;
        }

        &.item1 {
          background: url('../../assets/img/country/en.png') no-repeat center / 100% 100%;
        }

        &.item4 {
          background: url('../../assets/img/country/jp.png') no-repeat center / 100% 100%;
        }

        &.active {
          border: 2px solid #00CCFF;
          border-radius: 50%;
        }
      }
    }

    .info {

      display: flex;
      align-items: center;
      height: 70px;

      .lang,
      .esc {
        width: 34px;
        height: 34px;
        margin-top: -5px;
        border: 1px solid rgba(0, 207, 255, 0.8);
        border-radius: 4px;
        background-color: rgba(0, 58, 76, 0.78);
        box-shadow: inset 0 0 10px rgba(0, 213, 255, 0.22), 0 0 10px rgba(0, 213, 255, 0.24);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          border-color: #57e9ff;
          background-color: rgba(0, 87, 111, 0.88);
          box-shadow: inset 0 0 14px rgba(0, 213, 255, 0.4), 0 0 15px rgba(0, 213, 255, 0.4);
        }
      }

      .lang {
        margin-right: 24px;

        ::v-deep .el-dropdown {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        ::v-deep .lang-icon {
          width: 20px;
          height: 20px;
          display: block;
          cursor: pointer;
          background: url('../../assets/img/icon_yy.png') no-repeat center / contain;
        }
      }

      .esc {
        margin-right: 15px;
        background-image: url('../../assets/img/icon_tc.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 20px 20px;
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .site-header {
    width: 100%;

    .site-header-view {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 10px;
      padding-right: 20px;
      padding-top: 5px;
      position: relative;

      &::after {
        content: '';
        display: block;
        width: 97%;
        position: absolute;
        bottom: 0;
        height: 15px;
        background: url('../../assets/img/hd-line.png') no-repeat left / 100% auto;
      }

      .mobile-nav {
        display: block;
        position: relative;
        z-index: 9999;
        margin-left: 20px;

        i {
          font-size: 35px;
          color: #fff;
        }
      }

      .breadcrumb {
        display: flex;
        padding-left: 10px;
        align-items: center;

        .breadcrumb-item {
          color: #fff;
          display: flex;
          align-items: center;

          &:nth-child(1) {
            font-size: 20px;
            color: #01b2f5;
            display: none;
          }

          &:nth-child(2) {
            font-size: 20px;
            color: #01b2f5;
          }

          .b-arrow {
            content: '';
            display: none;
            width: 15px;
            height: 21px;
            margin: 0 5px;
            background: url('../../assets/img/breadcrumb-arrow.png') no-repeat center /100%;
          }
        }
      }

      .countrys {
        display: flex;

        .countrys-item {
          width: 40px;
          height: 40px;
          margin-right: 30px;
          border: 2px solid transparent;
          cursor: pointer;

          &.active {
            border: 2px solid #00CCFF;
            border-radius: 50%;
          }
        }
      }

      .info {

        display: flex;
        align-items: center;
        height: 70px;

        .lang,
        .esc {
          width: 46px;
          height: 46px;
          margin-top: -5px;
          border: 1px solid rgba(0, 207, 255, 0.8);
          border-radius: 4px;
          background-color: rgba(0, 58, 76, 0.78);
          box-shadow: inset 0 0 10px rgba(0, 213, 255, 0.22), 0 0 10px rgba(0, 213, 255, 0.24);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .lang {
          margin-right: 18px;

          ::v-deep .el-dropdown {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          ::v-deep .lang-icon {
            width: 26px;
            height: 26px;
            display: block;
            cursor: pointer;
            background: url('../../assets/img/icon_yy.png') no-repeat center / contain;
          }
        }

        .esc {
          margin-right: 15px;
          background-image: url('../../assets/img/icon_tc.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: 26px 26px;
        }
      }
    }
  }
}
</style>
